import { PropsWithChildren, memo } from 'react';

import Breadcrumb from '@/components/atomic/templates/navigation/breadcrumbs/components/breadcrumb';
import withExposer from '@/hocs/with-exposer';
import useStore from '@/state';
import getSecondaryNavParentList from '@/state/selectors/secondary-nav/get-secondary-nav-parent-list';
import { BasicComponentProps } from '@/typings/generic';

const BreadcrumbsListComponent: React.FC<
	PropsWithChildren & BasicComponentProps
> = ({ $exposerSuffix }) => {
	const secondaryNavParentList = useStore(getSecondaryNavParentList);

	if (!secondaryNavParentList) return null;

	return (
		<>
			{secondaryNavParentList.map((secondaryNavItem, index) => {
				const isFirstItem = index === 0;
				const isLastItem = index === secondaryNavParentList.length - 1;
				return (
					<Breadcrumb
						key={`${secondaryNavItem.title}_${secondaryNavItem.evaluatedLink}`}
						$exposerSuffix={$exposerSuffix}
						index={index}
						isFirstItem={isFirstItem}
						isLastItem={isLastItem}
						{...secondaryNavItem}
					/>
				);
			})}
		</>
	);
};

const BreadcrumbsList = memo(
	withExposer(BreadcrumbsListComponent, 'breadcrumbs_list'),
);

export default BreadcrumbsList;
